import type { TabContent } from './page-reducer';

export type Tab = {
  id: string;
  label: string;
  isActive: boolean;
  tabContent: TabContent;
};

export enum RevelioPageId {
  COMPANY_OVERVIEW = 'company-overview-v2',
  COMPANY_SCREENER = 'company-screener-v2',
  COMPANY_COMPOSITION = 'company-composition-v2',
  COMPANY_DIVERSITY = 'company-diversity',
  COMPANY_TRANSITIONS = 'company-transitions-v2',
  COMPANY_POSTINGS = 'company-postings',
  COMPANY_PAY = 'company-pay',
  COMPANY_SENTIMENT = 'company-sentiment',
  COMPANY_SUBSIDIARIES = 'company-subsidiaries',
  INDUSTRY_COMPOSITION = 'industry-composition',
  INDUSTRY_TRANSITIONS = 'industry-transitions',
  INDUSTRY_POSTINGS = 'industry-postings',
  INDUSTRY_PAY = 'industry-pay',
  INDUSTRY_MARKET_CONDITIONS = 'industry-market-conditions',
  INDUSTRY_SENTIMENT = 'industry-sentiment',
  GEOGRAPHY_OVERVIEW = 'geography-overview',
  GEOGRAPHY_SCREENER = 'geography-screener-v2',
  GEOGRAPHY_COMPOSITION = 'geography-composition-v2',
  GEOGRAPHY_TRANSITIONS = 'geography-transitions-v2',
  GEOGRAPHY_POSTINGS = 'geography-postings',
  GEOGRAPHY_PAY = 'geography-pay',
  GEOGRAPHY_MARKET_CONDITIONS = 'geography-market-conditions',
  GEOGRAPHY_SENTIMENT = 'geography-sentiment',
  ROLE_OVERVIEW = 'role-overview',
  ROLE_COMPOSITION = 'role-composition-v3',
  ROLE_SCREENER = 'role-screener-v2',
  ROLE_TRANSITIONS = 'role-transitions-v2',
  ROLE_POSTINGS = 'role-postings',
  ROLE_PAY = 'role-pay',
  ROLE_MARKET_CONDITIONS = 'role-market-conditions',
  ROLE_SENTIMENT = 'role-sentiment',
  SKILL_COMPOSITION = 'skill-composition',
  SKILL_POSTINGS = 'skill-postings',
  SKILL_PAY = 'skill-pay',
  SKILL_MARKET_CONDITIONS = 'skill-market-conditions',
  ACTIVITY_COMPOSITION = 'activity-composition',
  ACTIVITY_POSTINGS = 'activity-postings',
  ACTIVITY_PAY = 'activity-pay',
  ACTIVITY_MARKET_CONDITIONS = 'activity-market-conditions',
  TALENT_DISCOVERY = 'talent-discovery',
  POSTING_DISCOVERY = 'posting-discovery',
}

export const POSTINGS_PAGE_IDS: readonly RevelioPageId[] = [
  RevelioPageId.COMPANY_POSTINGS,
  RevelioPageId.INDUSTRY_POSTINGS,
  RevelioPageId.GEOGRAPHY_POSTINGS,
  RevelioPageId.ROLE_POSTINGS,
  RevelioPageId.SKILL_POSTINGS,
  RevelioPageId.ACTIVITY_POSTINGS,
] as const;

export const PAY_PAGE_IDS: readonly RevelioPageId[] = [
  RevelioPageId.COMPANY_PAY,
  RevelioPageId.INDUSTRY_PAY,
  RevelioPageId.GEOGRAPHY_PAY,
  RevelioPageId.ROLE_PAY,
  RevelioPageId.SKILL_PAY,
  RevelioPageId.ACTIVITY_PAY,
] as const;

export enum PageType {
  REVELIO_PUBLIC = 'REVELIO_PUBLIC',
  PRIVATE = 'PRIVATE',
  REPORT = 'REPORT',
}

export type Owner = { id?: string; username?: string };

type BasePageConfig = {
  id: string;
  name: string;
  tabs: Tab[];
  owner: Owner;
  created?: string;
};

type RevelioPublicPageConfig = BasePageConfig & {
  type: PageType.REVELIO_PUBLIC;
  revelioPageId: RevelioPageId;
};

type PrivatePageConfig = BasePageConfig & {
  type: PageType.PRIVATE;
  revelioPageId?: RevelioPageId;
};

export type ReportPageConfig = BasePageConfig & {
  type: PageType.REPORT;
  revelioPageId?: RevelioPageId;
  sampleFilterGroups?: string;
};

export type Page =
  | RevelioPublicPageConfig
  | PrivatePageConfig
  | ReportPageConfig;
